import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_CARD = 'summary_large_image';
export const DEFAULT_SITE = '@HubSpot';

function MetaTwitter({
  name,
  content: passedContent
}) {
  let content;

  if (passedContent) {
    content = passedContent;
  } else if (name === 'card') {
    content = DEFAULT_CARD;
  } else if (name === 'site') {
    content = DEFAULT_SITE;
  }

  if (!content) {
    console.error(`MetaTwitter: content required to render ${name} tag`);
  }

  return /*#__PURE__*/_jsx("meta", {
    name: `twitter:${name}`,
    content: content,
    "data-test-id": name
  });
}

export default MetaTwitter;